import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

function required(key) {
    const v = window.AnalyticsPortalConfig?.entra?.[key];
    if (!v) throw new Error(`AnalyticsPortalConfig.entra.${key} is not set. Check public/env.js.`);
    return v;
}

const tenantId = required('tenantId');
const clientId = required('clientId');
const authority = window.AnalyticsPortalConfig.entra.authority
    || `https://login.microsoftonline.com/${tenantId}`;

export const msalConfig = {
    auth: {
        clientId,
        authority,
        redirectUri: `${window.location.origin}/auth/callback`,
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                if (level === LogLevel.Error) console.error('[msal]', message);
                else if (level === LogLevel.Warning) console.warn('[msal]', message);
            },
            piiLoggingEnabled: false,
            logLevel: LogLevel.Warning,
        },
    },
};

export const apiScopes = [`api://${clientId}/access_as_user`];
export const msalInstance = new PublicClientApplication(msalConfig);
